import { PaintTarget } from '@ff-os/rendering-shared/targets';
import { Json } from '@ff-os/shared-json/Json';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { Svg } from 'ff-canvas';
import { SvgVariableInput } from './SvgVariableInput';
import { SvgVariableOptions } from './SvgVariableOptions';

export const svgToFfCanvas = (
    variable: GiftJson.Variable<SvgVariableOptions>,
    input: SvgVariableInput,
    palette: Json.Palette,
    target: PaintTarget,
    jwt: string | null
): Svg | Svg[] => {

    if (!input.assetUrl) {
        return [];
    }

    return {

        id: variable.id,
        type: 'svg',
        round: true,

        url: input.assetUrl,

        x: variable.x,
        y: variable.y,
        width: variable.width,
        height: variable.height,
        zIndex: variable.zIndex,
        angle: 0,

        scaleX: 1,
        scaleY: 1,
        alpha: input.alpha,

        shadow: input.shadow,
        shadowBlur: input.shadowBlur,
        shadowColor: input.shadowColor,
        shadowOffsetX: input.shadowOffsetX,
        shadowOffsetY: input.shadowOffsetY,

        stroke: input.stroke,
        strokeSize: input.strokeSize,
        strokeStyle: input.strokeStyle,

        custom: {
            watch: [],
            values: {}
        }
    };
};